import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { BrandMark } from '../../../shared/components/BrandLogo';

/**
 * Landing page after Google OAuth.
 * URL: /auth/callback?token=<jwt>
 * Stores the token and redirects to dashboard.
 */
export default function AuthCallback() {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [status, setStatus] = useState('Completing sign-in…');

  useEffect(() => {
    const token = params.get('token');
    const error = params.get('error');

    if (error || !token) {
      navigate(`/login?error=${error || 'callback_failed'}`);
      return;
    }

    loginWithToken(token)
      .then(() => {
        setStatus('Signed in! Redirecting…');
        navigate('/', { replace: true });
      })
      .catch(() => {
        navigate('/login?error=callback_failed');
      });
  }, []); // run once on mount

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0d1117, #161b22)',
      color: '#e6edf3',
      fontFamily: 'Inter, system-ui, sans-serif',
      gap: 16,
    }}>
      <BrandMark size={44} />
      <div className="spinner" style={{ width: 28, height: 28 }} />
      <div style={{ fontSize: 15, color: '#8b949e' }}>{status}</div>
    </div>
  );
}
